<template>
    <div class="surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">
                    <h3>Payment Details</h3>

                    <div v-if="loading" class="field">
                        <label>Loading payment details…</label>
                    </div>

                    <div v-else-if="error" class="field">
                        <label class="text-red-500">Error: {{ error }}</label>
                    </div>

                    <div v-else>
                        <div class="field">
                            <label>Description</label>
                            <InputText :disabled="true" :value="paymentFlowDetails.paymentRequest.description"/>
                        </div>

                        <div class="field">
                            <label>Amount</label>
                            <InputText :disabled="true" :value="paymentFlowDetails.paymentRequest.amount"/>
                        </div>

                        <div class="field">
                            <Button
                                label="Pay"
                                class="mr-2 mb-2"
                                :disabled="!readyToPay"
                                @click="pay"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {initDnaPayments} from '@/utils/loadExternalScriptOnce';
import DnaPaymentsService from "@/service/DnaPaymentsService";
import SystemConfigService from "@/service/SystemConfigService";

export default {
    name: 'GbpPaymentButton',
    props: {
        companyReference: {type: [String, Number], required: false, default: null},
        invoiceReference: {type: [String, Number], required: false, default: null},
        signatureReference: {type: [String, Number], required: false, default: null},
    },
    data() {
        return {
            loading: true,
            error: '',
            readyToPay: false,
            paymentFlowDetails: null
        };
    },
    async mounted() {
        try {
            // 1) Load DNA script once (safe to call multiple times across the app)
            // Init DNAPayments ONE TIME for the whole app
            try {
                const dnaPaymentsPaymentAPIJsUrl = await SystemConfigService.getDnaPaymentsPaymentAPIJsUrl();
                await initDnaPayments(dnaPaymentsPaymentAPIJsUrl.data);
            } catch (e) {
                console.error('[App] Could not init DNAPayments', e);
            }

            console.debug('[GbpPaymentButton][mounted] Getting payment details for : ',
                this.companyReference, this.invoiceReference, this.signatureReference);

            const res = await DnaPaymentsService.getPaymentFlowDetails(
                this.companyReference,
                this.invoiceReference,
                this.signatureReference
            );

            if (res.data.error) {
                this.error = res.data.error;
                console.log('[GbpPaymentButton][mounted] this.error = ', this.error);
                this.readyToPay = false;
            } else {
                this.paymentFlowDetails = res.data;
                console.log('[GbpPaymentButton][mounted] this.paymentFlowDetails  = ', this.paymentFlowDetails);
                this.readyToPay = true;
            }
        } catch (e) {
            console.error('[GbpPaymentButton][mounted] Error:', e);
            this.error = e?.message || 'Failed to get payment flow details';
        } finally {
            this.loading = false;
        }
    },
    methods: {
        pay() {
            try {
                var paymentRequest = this.paymentFlowDetails.paymentRequest;
                var config = this.paymentFlowDetails.config;
                var auth = this.paymentFlowDetails.auth;

                const tmpReturnUrl = config.baseReturnUrl + '/pcallback?result=success&ref=' + paymentRequest.merchantCustomData;
                const tmpFailureReturnUrl = config.baseReturnUrl + '/pcallback?result=error&ref=' + paymentRequest.merchantCustomData;
                const tmpCallbackUrl = config.baseCallbackUrl + '/pnotify';
                const tmpFailureCallbackUrl = config.baseCallbackUrl + '/pnotify';

                console.log('Open payment page with data: ',
                    tmpReturnUrl, tmpFailureReturnUrl, tmpCallbackUrl, tmpFailureCallbackUrl, paymentRequest);

                window.DNAPayments.openPaymentPage({
                        invoiceId: paymentRequest.invoiceId,
                        transactionType: paymentRequest.transactionType,
                        amount: parseFloat(paymentRequest.amount),
                        currency: 'GBP',
                        description: paymentRequest.description,
                        merchantCustomData: paymentRequest.merchantCustomData,
                        periodic: {
                            periodicType: 'ucof'
                        },
                        paymentSettings: {
                            terminalId: config.terminal,
                            returnUrl: tmpReturnUrl,
                            failureReturnUrl: tmpFailureReturnUrl,
                            callbackUrl: tmpCallbackUrl,
                            failureCallbackUrl: tmpFailureCallbackUrl
                        },
                        customerDetails: {
                            accountDetails: {
                                accountId: paymentRequest.accountId
                            },
                            billingAddress: {
                                firstName: paymentRequest.firstName,
                                lastName: paymentRequest.lastName,
                                addressLine1: paymentRequest.billingStreet1,
                                postalCode: paymentRequest.billingPostalCode,
                                city: paymentRequest.billingCity,
                                country: paymentRequest.billingCountry
                            },
                            email: paymentRequest.email,
                            firstName: paymentRequest.firstName,
                            lastName: paymentRequest.lastName
                        },
                        auth: {
                            access_token: auth.accessToken,
                            expires_in: 7200,
                            scope: 'payment integration_hosted',
                            token_type: 'Bearer'
                        }
                    }
                );
                console.log('Payment page opened');
            } catch (e) {
                console.error('[GbpPaymentButton][pay] Error:', e);
                this.error = 'Could not start payment.';
            }
        },
    },
};
</script>
